"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _countryCodeEmoji = require("country-code-emoji");
var _reactTippy = require("react-tippy");
var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _pricing = require("../../helpers/pricing");
var _booking = require("../../helpers/booking");
var _constants = require("../constants");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _formatting = require("../../helpers/formatting");
var CrewRow = function CrewRow(_ref) {
  var _member$profile;
  var member = _ref.member,
    user = _ref.user,
    deleteCrewMemberModal = _ref.deleteCrewMemberModal,
    booker = _ref.booker,
    currency = _ref.currency,
    isEventInFuture = _ref.isEventInFuture,
    isCrewMemberOnParentBooking = _ref.isCrewMemberOnParentBooking,
    isGroup = _ref.isGroup,
    isDeferred = _ref.isDeferred;
  var isMe = user && member.profile && member.profile.id === user.id;
  var userIsBooker = user && booker.id === user.id;
  var memberIsBooker = member.profile && member.profile.id === booker.id;
  var firstName = member.profile && member.profile.firstName ? member.profile.firstName : member.firstName;
  var lastName = member.profile && member.profile.lastName ? member.profile.lastName : member.lastName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--items__item flex flex-column flex-row@xs justify-between margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__left flex margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "left margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarSize: _constants.AVATAR_SIZES.MEDIUM,
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    avatarColor: _constants.AVATAR_COLORS.SECONDARY,
    image: ((_member$profile = member.profile) === null || _member$profile === void 0 ? void 0 : _member$profile.fbUid) && {
      url: "https://graph.facebook.com/v2.9/".concat(member.profile.fbUid, "/picture?type=square"),
      alt: member.profile.name
    },
    initials: (0, _formatting.getInitialsFromName)(firstName, lastName)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "right text-component"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "d8-u-font-size-base d8-u-ls-sm d8-u-font-primary d8-u-font-weight-300 d8-u-no-transform"
  }, "".concat((0, _formatting.capitalizeFirstLetter)(firstName), " ").concat((0, _formatting.capitalizeFirstLetter)(lastName)), member.okTransfers && !!member.okTransfers.length && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    position: "top",
    animation: "scale",
    arrow: "true",
    title: "Transfer ordered"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xxs"
  }, "\uD83D\uDE8C")), member.okSkiRental && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    position: "top",
    animation: "scale",
    arrow: "true",
    title: "Rental ordered"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xxs"
  }, "\uD83C\uDFBF"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex d8-u-color-contrast-medium"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm margin-right-sm"
  }, memberIsBooker ? 'Lead booker' : 'Crew', member.nationality && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    position: "top",
    animation: "scale",
    arrow: "true",
    title: member.nationality && (0, _booking.getCountryName)(member.nationality)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xxs"
  }, (0, _countryCodeEmoji.countryCodeEmoji)(member.nationality)))), !isCrewMemberOnParentBooking && !isGroup && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm padding-top-xxxxs margin-right-sm"
  }, "|"), !isCrewMemberOnParentBooking && !isGroup && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm margin-right-sm"
  }, isDeferred ? 'Total credit held' : 'Total paid', ":\xA0", /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-color-black"
  }, (0, _pricing.formatCurrency)((member.paidAmount || 0) / 100, currency)))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__right text-right text-component flex-shrink-0"
  }, isMe && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    position: "top",
    animation: "scale",
    arrow: "true",
    title: "Edit profile details"
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: "/account/edit"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "edit",
    className: "margin-left-sm icon--md",
    fill: _constants.COLORS.SECONDARY
  }))), !isCrewMemberOnParentBooking && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    position: "top",
    animation: "scale",
    arrow: "true",
    title: "Checked in?"
  }, member.checkedIn ? /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "checkmark",
    className: "margin-left-sm icon--md",
    fill: _constants.COLORS.PRIMARY
  }) : /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "cross",
    className: "margin-left-sm icon--md",
    fill: _constants.COLORS.ERROR
  })), userIsBooker && isEventInFuture && !isCrewMemberOnParentBooking && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    position: "top",
    animation: "scale",
    arrow: "true",
    title: "Remove Crew Member"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "trash",
    buttonType: _constants.BUTTON_TYPES.TRASH,
    onClick: function onClick() {
      return deleteCrewMemberModal(member);
    }
  }))));
};
CrewRow.propTypes = {
  currency: _propTypes["default"].string.isRequired,
  member: _propTypes["default"].object.isRequired,
  user: _propTypes["default"].object,
  deleteCrewMemberModal: _propTypes["default"].func,
  booker: _propTypes["default"].object.isRequired,
  isEventInFuture: _propTypes["default"].bool,
  isCrewMemberOnParentBooking: _propTypes["default"].bool,
  isGroup: _propTypes["default"].bool,
  isDeferred: _propTypes["default"].bool
};
CrewRow.defaultProps = {
  isGroup: false
};
var _default = exports["default"] = CrewRow;